module.exports = __webpack_public_path__ + "img/41.bd83ac72.jpg";